import { useTranslation } from 'react-i18next';

import * as s from './styles';
import type { IRegionsOrder, IPricingModalImageData } from './types';

import pricingModalImage from './static/pricing-modal-image.jpg';

const Headline = () => {
  const { t } = useTranslation();
  return (
    <s.StyledHeadline forwardedAs="h2" variant="h4">{t('organisms_pricing_modalContent_headline')}</s.StyledHeadline>
  );
};

const Rates = () => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language;

  const regionOrders: IRegionsOrder = {
    'en-US': ['regionUSA', 'regionCanada', 'regionUK', 'regionAUS', 'regionNZ', 'regionIreland', 'regionFrance', 'regionGermany', 'regionNetherlands'],
    'en-GB': ['regionUK', 'regionIreland', 'regionFrance', 'regionGermany', 'regionNetherlands', 'regionUSA', 'regionCanada', 'regionAUS', 'regionNZ' ],
    'fr-FR': ['regionFrance', 'regionUK', 'regionIreland', 'regionGermany', 'regionNetherlands', 'regionUSA', 'regionCanada', 'regionAUS', 'regionNZ'],
  };

  const regionOrder = regionOrders[currentLocale] || regionOrders['en-US'];

  return (
    <s.CreditBreakdown>
        {regionOrder.map((regionKey: string) => (
          <s.Region key={regionKey}>
            {t(`_pricing_rates_${regionKey}_regionName`)}
            <s.RegionCredits>
              <s.CreditEntry>{t(`organisms_pricing_rates_${regionKey}_creditEntrySms`)}</s.CreditEntry>
              <s.CreditEntry>{t(`organisms_pricing_rates_${regionKey}_creditEntryMms`)}</s.CreditEntry>
            </s.RegionCredits>
          </s.Region>
        ))}
    </s.CreditBreakdown>
  );
};

const ModalContent = ({ imageData, ...rest }: { imageData?: IPricingModalImageData; }) => {
  const { t } = useTranslation();
  return (
    <s.StyledPricingModalContent {...rest}>
      <s.TextColumn>
        <Headline />
        <s.Copy
          dangerouslySetInnerHTML={{
            __html: `
              <p>${t('organisms_pricing_modalContent_copyText1')}</p>
              <p>${t('organisms_pricing_modalContent_copyText2')}</p>
            `,
          }}
          variant="paragraph2"
        />
        <Rates />
      </s.TextColumn>
      {imageData?.file?.childImageSharp?.gatsbyImageData && (
        <s.MediaColumn>
          <s.Image alt="" src={pricingModalImage} />
        </s.MediaColumn>
      )}
    </s.StyledPricingModalContent>
  );
};

const StaticPricingModalContent = ({ imageData, ...rest }: { imageData?: IPricingModalImageData; }) => (<ModalContent imageData={imageData} {...rest} />);

export default StaticPricingModalContent;
